import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';
import Warning from './Warning';

const notGood = (warnings, notReadyMessage) => {
  return (
    <div>
      <div className="ConfirmSetLive-not-good">
        <span className="header">{notReadyMessage}</span>
        Please review the errors below before proceeding.
      </div>
      {warnings}
    </div>
  );
};

const getWarnings = (steps, changeStep, globalValidation) => {
  let warnings = [];
  steps.forEach((step, index) => {
    if (!step.isValid) {
      warnings.push(
        <Warning
          key={index + 1}
          stepNumber={index + 1}
          description={step.warning}
          changeStep={changeStep}
        />
      );
    }
  });

  if (globalValidation && !globalValidation.isValid) {
    warnings.push(
      <Warning
        key={0}
        stepNumber={1}
        description={globalValidation.warning}
        changeStep={changeStep}
      />
    );
  }

  return warnings;
};
const allGood = (readyMessage) => {
  return (
    <div className="ConfirmSetLive-all-good">
      <span className="header">{readyMessage}</span>
      Please hit set live to confirm and save.
    </div>
  );
};

const ConfirmSetLive = ({
  steps,
  globalValidation,
  notReadyMessage,
  readyMessage,
  changeStep,
}) => {
  const warnings = getWarnings(steps, changeStep, globalValidation);
  const areWarnings = warnings.length !== 0;
  return (
    <div className="ConfirmSetLive">
      {areWarnings ? notGood(warnings, notReadyMessage) : allGood(readyMessage)}
    </div>
  );
};

ConfirmSetLive.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      isValid: PropTypes.bool,
      warning: PropTypes.string,
    })
  ),
  changeStep: PropTypes.func,
  notReadyMessage: PropTypes.string,
  readyMessage: PropTypes.string,
};

export default ConfirmSetLive;
